export { default } from "./LessonResourceGraphics";
